(() => {
  const root = document.getElementById('btk-halloween-decor');
  if (!root || root.dataset.ready === 'true' || location.pathname.startsWith('/checkout')) return;
  root.dataset.ready = 'true';
  document.body.dataset.btkHalloweenDecor = 'on';
  root.hidden = false;
  let frame;
  const update = () => {
    frame = undefined;
    const blocked = [...document.querySelectorAll('dialog[open], [data-btk-welcome-popup]:not([hidden])')]
      .some(element => element.getBoundingClientRect().width > 0);
    root.toggleAttribute('data-blocked', blocked);
    root.toggleAttribute('data-paused', document.hidden);
  };
  const schedule = () => { if (frame === undefined) frame = requestAnimationFrame(update); };
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden'] });
  document.addEventListener('visibilitychange', schedule);
  update();
})();
